export interface ICountiesState {
  counties: ICounties[];
  states: IStateStore[];
  areas: IAreaStore[];
}

let countiesState: ICountiesState = {
  counties: [],
  states: [],
  areas: [],
};

export default countiesState;

export interface ICounties {
  name: string;
  codeSerpro: number;
  codeIbge: number;
  areaInfluenciaNome: string;
  regiaoOperacionalNome: string;
  capital: boolean;
  author: string;
  id?: string;
  state: string;
}

export interface IStateStore {
  id: string;
  name: string;
  sigla: string;
}

export interface IAreaStore {
  id: number;
  name: string;
  code: number;
}

export interface ICityLocal {
  id: string | null;
  name: string;
  codeSerpro: number | null;
  codeIbge: string;
  capital: { label: string; value: boolean | null };
  state: { label: string; value: string | null };
  area: { label: string; value: string | null };
}
